<div
    *ngIf="filteredAutocompleteOptions$ | async as filteredAutocompleteOptions"
    class="input-container h100p"
    [ngClass]="{'labeled': label}"
    [class.teams]="teamsApp"
>
    <div *ngIf="isShowLabel && label" class="label-container">
        <span class="input-label" [class.required]="alwaysShowRequiredIndicator || required">{{doTranslate ? (label | translate) : label }}</span>
        <app-tooltip *ngIf="tooltip" [options]="tooltip" [doTranslate]="doTranslate"></app-tooltip>
    </div>

    <ng-container *ngIf="type === 'file'">
        <ng-container *ngTemplateOutlet="fileInput"></ng-container>
    </ng-container>

    <ng-container *ngIf="type !== 'file'">
        <div [matTooltip]="disabledText" matTooltipPositionAtOrigin="true" class="tooltip-container">
        <div class="text-box-container" [ngSwitch]="type" [ngClass]="{'cPointer': readonly || type === 'file', 'cPointer pen': isDisabled}">
            <app-icon class="input-icon prepend" [ngClass]="{'light': lightTheme}" *ngIf="prependIcon" [faIcon]="prependIcon"></app-icon>
            <input *ngSwitchCase="'phone'"
                [id]="inputId"
                type="text" 
                matInput
                ng2TelInput
                class="intl-phone-number"
                [ngClass]="{'cPointer': readonly}"
                [ng2TelInputOptions]="{ utilsScript: '/assets/js/intl-tel-input-utils.js' }"
                [ng2TelInputSelectedCountryTabIndex]="phoneCountryTabIndex"
                [required]="required" [readonly]="readonly || isDisabled || formControl?.disabled"
                [placeholder]="placeholder ? (doTranslate ? (placeholder | translate) : placeholder) : '' "
                [disabled]="isDisabled || formControl?.disabled"
                [ngModel]="value"
                [ngClass]="{
                    'readonly': readonly,
                    'disabled' : isDisabled || formControl?.disabled,
                    'clickable': isClickable,
                    'dark': dark,
                    'light': light,
                    'icon-padding': prependIcon,
                    'pL10': !prependIcon,
                    'pR30': appendIcon,
                    'pR10': !appendIcon
                }"
                (ngModelChange)="setValue($event)"
                (blur)="blur()"
                (focus)="focus()"
                (countryChange)="onCountryChange($event)"
                [autocomplete]="hideAutoComplete ? isIeOrEdge ? 'disabled' : 'off' : 'new-password'"
                #input
                [style.width]="width ? width : '100%'"
                [style.borderBottomColor]="(focused$ | async) ? bottomBorderColor ?? 'var(--input-bottom-border-color)' : 'transparent'"
                [style.backgroundColor]="backgroundColor ?? null"
            >

            <ng-container *ngSwitchDefault>
                <input *ngIf="lineCount < 2"
                    [id]="inputId"
                    [placeholder]="placeholder ? (doTranslate ? (placeholder | translate) : placeholder) : '' "
                    [disabled]="isDisabled || isObfuscated || formControl?.disabled"
                    [readonly]="readonly || isDisabled || isObfuscated || formControl?.disabled"
                    [ngClass]="{
                        'cPointer': readonly,
                        'icon-padding': prependIcon,
                        'pL10': !prependIcon,
                        'pR30': appendIcon,
                        'pR10': !appendIcon,
                        'showing-drop-down': (showDropDown$ | async) && filteredAutocompleteOptions?.length,
                        'disabled' : isDisabled || formControl?.disabled,
                        'clickable': isClickable,
                        'dark': dark,
                        'light': lightTheme || light,
                        'space-on-right': appendIcon
                    }"
                    [type]="type"
                    [ngModel]="displayValue$ | async"
                    (ngModelChange)="setValue($event)"
                    (blur)="blur()"
                    (focus)="focus()"
                    [autocomplete]="hideAutoComplete ? isIeOrEdge ? 'disabled' : 'off' : 'new-password'"
                    (keydown)="onKeyPress($event)"
                    (paste)="onPaste($event)"
                    [maxLength]="!!maxLength ? maxLength : DEFAULT_MAX_LENGTH"
                    #input
                    [style.padding-left]="prependIcon ? '35px' : '10px'"
                    [style.padding-right]="appendIcon ? '35px' : '10px'"
                    [style.width]="width ? width : '100%'"
                    [style.height]="height ? height : '100%'"
                    [style.borderBottomColor]="(focused$ | async) ? bottomBorderColor ?? 'var(--input-bottom-border-color)' : 'transparent'"
                    [style.backgroundColor]="backgroundColor ?? null"
                    [attr.data-testid]="'TextField-Input-' + inputId"
                >

                <textarea *ngIf="lineCount > 1"
                    [id]="inputId"
                    [placeholder]="placeholder ? (doTranslate ? (placeholder | translate) : placeholder) : '' "
                    [disabled]="isDisabled || isObfuscated || formControl?.disabled"
                    [readonly]="readonly || isDisabled || isObfuscated || formControl?.disabled"
                    [ngClass]="{
                        'cPointer': readonly,
                        'icon-padding': prependIcon,
                        'pL10': !prependIcon,
                        'pR30': appendIcon,
                        'pR10': !appendIcon,
                        'showing-drop-down': (showDropDown$ | async) && filteredAutocompleteOptions?.length,
                        'disabled' : isDisabled || formControl?.disabled,
                        'clickable': isClickable,
                        'dark': dark,
                        'light': lightTheme || light,
                        'space-on-right': appendIcon
                    }"
                    [style.resize]="'none'"
                    [ngModel]="displayValue$ | async"
                    (ngModelChange)="setValue($event)"
                    (blur)="blur()"
                    (focus)="focus()"
                    [autocomplete]="hideAutoComplete ? isIeOrEdge ? 'disabled' : 'off' : 'new-password'"
                    (keydown)="onKeyPress($event)"
                    (paste)="onPaste($event)"
                    [maxLength]="!!maxLength ? maxLength : DEFAULT_MAX_LENGTH"
                    #input
                    [style.padding-left]="prependIcon ? '35px' : '10px'"
                    [style.padding-right]="appendIcon ? '35px' : '10px'"
                    [style.width]="width ? width : '100%'"
                    [style.height]="height ? height : '100%'"
                    [style.borderBottomColor]="(focused$ | async) ? bottomBorderColor ?? 'var(--input-bottom-border-color)' : 'transparent'"
                    [style.backgroundColor]="backgroundColor ?? null"
                    [rows]="lineCount"
                ></textarea>
            </ng-container>
            
            <app-icon
                *ngIf="appendIcon"
                class="input-icon append"
                [ngClass]="[appendIconClass ? appendIconClass : '']"
                [class.light]="lightTheme"
                [class.has-actions]="appendActions?.length"
                [faIcon]="appendIcon"
            ></app-icon>
        </div>
        <div *ngIf="appendActions?.length" class="append-actions-container">
            <app-icon class="cPointer" [matMenuTriggerFor]="appendActionsMenu" [icon]="{'faIcon': 'fas fa-chevron-down', 'fontSize': '14px'}" (click)="$event.stopPropagation()"></app-icon>
        </div>
        </div>
</ng-container>

    <div *ngIf="filteredAutocompleteOptions?.length" class="drop-down"
        [ngClass]="{ 'light': lightTheme, 'hidden': (showDropDown$ | async) === false, 'disabled' : isDisabled }" appClickOutside
        (clickOutside)="toggleDropDown(false)">
        <div class="autocomplete-options">
            <button class="option" [ngClass]="{'light': lightTheme}" *ngFor="let option of filteredAutocompleteOptions"
                (click)="selectAutocomplete(option); $event.stopPropagation()">
                <div class="option-label">
                    {{ option.value }}
                </div>
            </button>
        </div>
    </div>
    <div *ngIf="showErrors" class="error-container" [ngClass]="[errorClass ? errorClass : '']">
        <mat-error *ngIf="formControl?.hasError('emailOrPhone')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.emailOrPhone' | translate }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('email')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.email' | translate:{ label: (label | translate) } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('maxlength') || (maxLengthReached$ | async)"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.maxlength' | translate:{ label: (label | translate), length: formControl?.errors?.maxlength?.requiredLength ?? maxLength } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('minlength')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.minlength' | translate:{ label: (label | translate), length: formControl.errors.minlength.requiredLength } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('number')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.number' | translate:{ label: (label | translate) } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('phoneNumber') && formControl?.touched"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.phoneNumber' | translate:{ label: (label | translate) } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('required') && formControl?.touched"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.required' | translate:{ label: (label | translate) } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('uniqueInArray')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.uniqueInArray' | translate:{ label: (label | translate) } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('uniqueInLookUpMap')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.uniqueInLookUpMap' | translate:{ label: (label | translate) } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('max')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.max' | translate:{ label: (label | translate), val: formControl.errors.max.max } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('min')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.min' | translate:{ label: (label | translate), val: formControl.errors.min.min } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('lessThan')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.lessThan' | translate:{ label: (label | translate), val: formControl.errors.lessThan.max } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('greaterThan')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.greaterThan' | translate:{ label: (label | translate), val: formControl.errors.greaterThan.min } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('greaterThanOrEqual')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.greaterThanOrEqual' | translate:{ label: (label | translate), val: formControl.errors.greaterThanOrEqual.min } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('lessThanOrEqual')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.lessThanOrEqual' | translate:{ label: (label | translate), val: formControl.errors.lessThanOrEqual.max } }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('companyExists')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.companyExists' | translate }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('siteNameExisting')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.siteNameExisting' | translate }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('pattern')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.pattern' | translate }}</mat-error>
        <mat-error *ngIf="formControl?.hasError('stringMatch')"><app-icon [faIcon]="'fas fa-exclamation-circle'"></app-icon>{{ 'formValidation.stringMatch' | translate:{ val: formControl.errors.stringMatch.matchValue } }}</mat-error>
    </div>
</div>

<!-- isolated to so icons can be encapsulated with file input clicks-->
<ng-template #fileInput>
    <div [matTooltip]="disabledText" matTooltipPositionAtOrigin="true">
        <div class="text-box-container h100p" class="cPointer">
            <div class="file-input-container">
                <app-icon class="input-icon prepend" [ngClass]="{'light': lightTheme}" *ngIf="prependIcon" [faIcon]="prependIcon"></app-icon>
        
                <input
                    class="cPointer"
                    [id]="inputId"
                    [placeholder]="placeholder ? (doTranslate ? (placeholder | translate) : placeholder) : '' "
                    [disabled]="isDisabled"
                    [ngClass]="{
                        'icon-padding': prependIcon,
                        'pL10': !prependIcon,
                        'pR30': appendIcon,
                        'pR10': !appendIcon,
                        'light': lightTheme,
                        'showing-drop-down': (showDropDown$ | async) && (filteredAutocompleteOptions$ | async)?.length,
                        'disabled' : isDisabled,
                        'clickable': isClickable,
                        'dark': dark
                    }"
                    [ngModel]="value"
                    (blur)="blur()"
                    (focus)="focus()"
                    autocomplete="off"
                    #input
                    [style.padding-left]="prependIcon ? '35px' : 0"
                    [style.padding-right]="appendIcon ? '35px' : 0"
                    [style.width]="width ? width : '100%'"
                >
        
                <input type="file"
                    name="file"
                    class="file-input"
                    [id]="inputId + '-file'"
                    accept="{{acceptableFileTypes}}"
                    (change)="setFileValue($event)"
                    [style.padding-left]="prependIcon ? '35px' : 0"
                    [style.padding-right]="appendIcon ? '35px' : 0"
                    [style.width]="width ? width : '100%'"
                >
        
                <app-icon class="input-icon append" [ngClass]="[appendIconClass ? appendIconClass : '', lightTheme ? 'light' : '']" *ngIf="appendIcon" [faIcon]="appendIcon"></app-icon>
                <label class="upload-label" [for]="inputId + '-file'"></label>
            </div>
        </div>
    </div>
</ng-template>

<mat-menu id="append-actions-menu" class="append-actions-menu" #appendActionsMenu="matMenu" yPosition="below" xPosition="after">
    <button mat-menu-item *ngFor="let item of appendActions" class="append-actions-menu-item flexRow jcC aiC" (click)="item.action()" [disabled]="item.disabled">
        {{ item.textKey | translate }}
    </button>
</mat-menu>
